// libs
import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Badge } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack, Tooltip, Typography } from '@lyearn/ui';
import BadgeCard from '@/modules/corporate/modules/badges/components/BadgeCard';
import { BadgeType } from '@/types/schema';

const Badges = ({ badges }: { badges?: BadgeType[] }) => {
  const { t } = useTranslation();

  const renderer = useCallback(() => {
    if (!badges) return null;
    return (
      <Stack className="!w-[39rem] !h-[19rem] overflow-hideen">
        <Stack className="w-full h-full overflow-y-auto p-4" direction="col">
          <Typography className="text-text-primary" variant="heading-xs">
            Earned Badges
          </Typography>
          <Typography className="text-text-secondary mt-4" variant="body-short-02">
            Finish the article to earn badges
          </Typography>
          <Stack className="w-full pe-12" direction="col">
            {badges.map((badge) => {
              return <BadgeCard key={badge.id} badge={badge!} />;
            })}
          </Stack>
        </Stack>
      </Stack>
    );
  }, [badges]);

  if (!badges?.length) {
    return null;
  }

  return (
    <Tooltip
      classes={{
        popper: 'z-50',
        tooltip:
          'bg-white border-0 !w-[40rem] !max-w-[40rem] !max-h-[21rem] !border-white text-black  rounded-md',
        arrow: 'text-white',
      }}
      placement="top"
      title={renderer()}>
      <Box
        className={cn(
          'flex h-40 ml-12 mt-12  w-max bg-white items-center justify-center rounded-8 border border-border ps-8 pe-12 xs:flex-row xs:px-12',
        )}>
        <Badge className="me-8" fillColorToken="yellow-600" height={20} width={20} />
        <Typography color="text-text-paragraph" variant="body-short-02">
          {t('Common:Badges')}: {badges.length}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default Badges;
